document.querySelector("#sign_in_button").addEventListener('click', async (event) => {
    event.preventDefault();

    const passwordField = document.querySelector('#customer-password');
    const emailField = document.querySelector('#customer-email');
    const loginForm = document.querySelector('#customer_login');
    const spinner = document.querySelector(".lds-ring");

    spinner.style.display = "flex";
    if (passwordField.value && emailField.value) {

        const requestData = {
            email: emailField.value,
            password: passwordField.value
        };

        try {
            const response = await fetch('/apps/rcapp/customerCheckPassword', {
                method: 'POST',
                body: JSON.stringify(requestData),
                headers: {
                    'Content-Type': 'application/json'
                } 
            });
      
            if (response.ok) {
                loginForm.submit();
            } else {
                console.error('Réponse non valide du serveur. Statut :', response.status);
                loginForm.submit();
            }
          } catch (error) {
            console.error('Erreur lors de la requête :', error);
          }
    }
});